import { css } from '@emotion/css'
import Box from '@mui/material/Box'
import IconButton from '@mui/material/IconButton'
import Typography from '@mui/material/Typography'
import { observer } from 'mobx-react'
import React from 'react'
import { useIntl } from 'react-intl'
import FileInput from '../../../../../components/customElements/FileInput/FileInput'
import { getImageSrc } from '../../../../../helpers/getImageSrc'
import fxStyles from '../../../../../utils/styles/fxStyles'

export type DefaultImageItem = {
  url: string
  file: File
}

interface NewPhotoUploadFormProps {
  image?: DefaultImageItem
  collection: DefaultImageItem[]
  setImage: (image: DefaultImageItem) => void
  deleteImage: (image: DefaultImageItem) => void
}

function PhotoUploadForm({
  image,
  collection,
  setImage,
  deleteImage,
}: NewPhotoUploadFormProps) {
  const intl = useIntl()

  return !image ? (
    <FileInput
      multiple={true}
      file={null}
      setFile={setImage}
      fileTypes={['JPEG', 'JPG', 'PNG']}
      classes={css({ height: '76px' })}
      fileName
      label={intl.formatMessage({ id: 'Загрузите или перетащите файл сюда' })}
      uploadedLabel={intl.formatMessage({
        id: 'Загрузите или перетащите файл сюда',
      })}
    />
  ) : (
    <Box
      sx={{
        borderRadius: '8px',
        background: 'grey[200]',
        ...fxStyles.alnCenter,
      }}
    >
      <Box className={'aln-center'}>
        <img
          alt={''}
          src={image.url}
          width={64}
          height={64}
          className={css({ borderRadius: '4px' })}
        />
      </Box>
      <Box ml={1.5} className={'aln-center'}>
        <Typography variant={'body1'} sx={{ overflowWrap: 'anywhere' }}>
          {collection.find((el) => el.url === image?.url)?.file?.name || ''}
        </Typography>
      </Box>
      <IconButton
        sx={{ height: '32px', width: '32px' }}
        onClick={() => deleteImage(image)}
      >
        <img alt={''} src={getImageSrc('close')} width={18} height={18} />
      </IconButton>
    </Box>
  )
}

export default observer(PhotoUploadForm)
